/**
 * Checkout Entry Point
 *
 * Mounts the CheckoutForm component on the checkout page.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShopProvider } from '@/context';
import { CheckoutForm } from '@/components/Checkout';

const container = document.getElementById('evcs-checkout');

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ShopProvider>
        <CheckoutForm />
      </ShopProvider>
    </StrictMode>
  );
}
